import { BorderType } from 'grommet/utils';

type BoxSideType = 'top' | 'left' | 'bottom' | 'right' | 'start' | 'end' | 'horizontal' | 'vertical' | 'all' | 'between';

export function getBorderStyle(side: BoxSideType): BorderType {
  return { side, size: 'small', color: 'background-back' };
}
